/* Раздел «Запросы в NetBox». Гамма и размеры — как у вкладки «Порты». */
.page { flex: 1; overflow-y: auto; padding: 28px 32px 40px; background: var(--bg); }

.header { margin-bottom: 16px; }
.title {
  margin: 0; font-size: 26px; font-weight: 650; line-height: 1.2; letter-spacing: -.01em; color: var(--text);
}
.subtitle { margin: 4px 0 0; font-size: 14px; color: var(--text2); }

/* Шаги согласования: свой шаг пользователя выделен */
.steps {
  display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px;
  max-width: 980px; margin: 0 0 12px; padding: 0; list-style: none;
}
.step {
  display: flex; gap: 12px; align-items: flex-start; padding: 14px 16px;
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-md);
}
.stepMine { background: var(--blue-lt); border-color: color-mix(in srgb, var(--blue) 40%, transparent); }
.stepNum {
  display: grid; place-items: center; flex-shrink: 0; width: 26px; height: 26px;
  font-size: 13px; font-weight: 650; color: var(--text2);
  background: var(--table-even); border: 1px solid var(--border); border-radius: 50%;
}
.stepMine .stepNum { color: #fff; background: var(--blue); border-color: var(--blue); }
.stepText { display: flex; flex-direction: column; gap: 2px; }
.stepTitle { font-size: 14px; font-weight: 600; color: var(--text); }
.stepWho { font-size: 13px; line-height: 1.4; color: var(--text2); }

.duty {
  max-width: 980px; margin-bottom: 20px; font-size: 13.5px; line-height: 1.5; color: var(--text2);
}

.tabs { display: flex; gap: 4px; margin-bottom: 14px; overflow-x: auto; border-bottom: 1px solid var(--border); scrollbar-width: none; }
.tab {
  display: inline-flex; align-items: center; gap: 8px; height: 40px; padding: 0 14px; margin-bottom: -1px;
  font-size: 14px; font-weight: 500; color: var(--text2);
  white-space: nowrap; flex-shrink: 0;
  background: none; border: none; border-bottom: 2px solid transparent; cursor: pointer;
}
.tab:hover { color: var(--text); }
.tabActive, .tabActive:hover { color: var(--text); border-bottom-color: var(--blue); }
.count {
  padding: 0 7px; font-size: 12px; font-weight: 600; line-height: 20px;
  color: var(--text2); background: var(--border); border-radius: var(--r-pill);
}

.tableWrap { overflow-x: auto; background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-md); }
.table { width: 100%; border-collapse: collapse; }
.table th {
  padding: 10px 12px; text-align: left; white-space: nowrap;
  font-size: 12.5px; font-weight: 600; color: var(--text2);
  background: var(--card-bg); box-shadow: inset 0 -1px 0 var(--border);
}
.table td { padding: 10px 12px; font-size: 13.5px; color: var(--text); border-bottom: 1px solid var(--border); vertical-align: middle; }
.table tbody tr:last-child td { border-bottom: none; }
.row { cursor: pointer; }
.row:hover td { background: var(--table-hover); }
.rowWarn { background: var(--warn-bg); box-shadow: inset 3px 0 0 var(--warn); }
.num { font-weight: 700; font-variant-numeric: tabular-nums; }
.strong { font-weight: 600; white-space: nowrap; }
.muted { color: var(--text2); }
.mono { font-family: var(--mono); font-size: 12px; }
.none { padding: 18px; font-size: 13px; text-align: center; color: var(--text2); }
.actions { display: flex; gap: 6px; justify-content: flex-end; flex-wrap: wrap; }

.pill { display: inline-block; padding: 2px 10px; font-size: 12px; font-weight: 600; white-space: nowrap; border-radius: var(--r-pill); }
.tone_info { color: var(--blue); background: var(--table-hover); }
.tone_ok { color: var(--ok); background: var(--ok-bg); }
.tone_warn { color: var(--warn); background: var(--warn-bg); }
.tone_err { color: var(--err); background: var(--err-bg); }
.tone_muted { color: var(--text2); background: var(--table-even); }

.error, .ok { margin-bottom: 12px; padding: 10px 14px; font-size: 13px; border-radius: var(--r-md); }
.error { color: var(--err); background: var(--err-bg); }
.ok { color: var(--ok); background: var(--ok-bg); }

.button {
  height: 34px; padding: 0 13px; font-size: 13.5px; font-weight: 500; color: var(--text); white-space: nowrap;
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-sm); cursor: pointer;
}
.button:hover { border-color: var(--slate-lt); }
.button:disabled { opacity: .5; cursor: default; }
.primary { color: #fff; background: var(--blue); border-color: var(--blue); }
.primary:hover { color: #fff; background: var(--blue-dark); border-color: var(--blue-dark); }
.danger { color: var(--err); border-color: var(--err); }
.danger:hover { color: #fff; background: var(--err); border-color: var(--err); }

/* ── Карточка ── */
.back { margin-bottom: 10px; padding: 0; font-size: 13.5px; color: var(--blue); background: none; border: none; cursor: pointer; }
:global(html.dark) .back { color: var(--navy-accent); }
.detailHead { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 14px; }

.timeline { max-width: 900px; margin-bottom: 18px; border-left: 2px solid var(--border); padding-left: 16px; }
.event { position: relative; margin-bottom: 12px; }
.event::before {
  content: ''; position: absolute; left: -22px; top: 5px; width: 10px; height: 10px;
  background: var(--card-bg); border: 2px solid var(--blue); border-radius: 50%;
}
.eventHead { font-size: 13.5px; color: var(--text); }
.quote {
  margin-top: 6px; padding: 8px 12px; font-size: 13px; line-height: 1.5; white-space: pre-wrap;
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.diff { margin-top: 6px; font-size: 12.5px; line-height: 1.6; color: var(--warn); }
.errors { margin: 6px 0 0 18px; padding: 0; font-size: 12.5px; color: var(--err); }

.snapshot { display: grid; gap: 16px; max-width: 900px; margin-bottom: 90px; }
.section { display: grid; gap: 6px; }
.sectionTitle { font-size: 15px; font-weight: 600; color: var(--text); }
.sectionNote { font-size: 12px; color: var(--warn); }

/* Действия прилипают к низу: решение принимается, прокрутив снимок */
.actionBar {
  position: sticky; bottom: -40px; display: grid; gap: 8px; max-width: 900px; margin-top: -70px;
  padding: 12px 14px; background: var(--card-bg); border: 1px solid var(--border);
  border-radius: var(--r-md); box-shadow: 0 -6px 20px var(--shadow);
}
.actionRow { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 12.5px; }
.spacer { flex: 1; }
.comment {
  width: 100%; padding: 8px 10px; font: inherit; font-size: 13px; color: var(--text); resize: vertical;
  background: var(--input-bg, var(--card-bg)); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.comment:focus { border-color: var(--blue); outline: none; }

@media (max-width: 1023px) {
  .steps { grid-template-columns: 1fr; }
}

@media (max-width: 699px) {
  .page { padding: 20px 16px 32px; }
  .title { font-size: 22px; }
  .hideMobile { display: none; }
  .actions { justify-content: flex-start; }
}
